import { fg } from '@atlaskit/platform-feature-flags';
import type {
	AtlasEntityATI,
	CloudGraphBranchEntityAti,
	CloudGraphCalendarEventEntityAti,
	CloudGraphCommentEntityAti,
	CloudGraphCommitEntityAti,
	CloudGraphConversationEntityAti,
	CloudGraphCustomerContactEntityAti,
	CloudGraphCustomerOrgEntityAti,
	CloudGraphDashboardEntityAti,
	CloudGraphDataTableEntityAti,
	CloudGraphDealEntityAti,
	CloudGraphDesignEntityAti,
	CloudGraphDocumentEntityAti,
	CloudGraphMessageEntityAti,
	CloudGraphProjectEntityAti,
	CloudGraphPullRequestEntityAti,
	CloudGraphRemoteLinkEntityAti,
	CloudGraphRepositoryEntityAti,
	CloudGraphSpaceEntityAti,
	CloudGraphVideoEntityAti,
	CloudGraphWorkItemEntityAti,
	ConfluenceEntityATI,
	EntityATI,
	FederatedEmailEntityAti,
	JiraEntityATI,
	MercuryEntityATI,
	MercuryProductEntityATI,
	PassionfruitEntityATI,
	SlackEntityType,
	TalentEntityATI,
} from '@atlassian/search-client';

export const DEFAULT_ATLAS_ENTITY_ATI: AtlasEntityATI[] = [
	'ati:cloud:townsquare:project',
	'ati:cloud:townsquare:goal',
	'ati:cloud:townsquare:tag',
	// 'ati:cloud:townsquare:question',
	// 'ati:cloud:townsquare:learning',
];

export const DEFAULT_MERCURY_ENTITY_ATI: MercuryEntityATI[] = [
	'ati:cloud:mercury:focus-area',
	'ati:cloud:mercury:focus-area-status-update',
];

export const PASSIONFRUIT_ASK_ENTITY_ATI: PassionfruitEntityATI = 'ati:cloud:passionfruit:ask';

export const getMercuryEntityAti = (): MercuryProductEntityATI[] => [
	...DEFAULT_MERCURY_ENTITY_ATI,
	...(fg('platform_passionfruit_search_onboarding_enabled') ? [PASSIONFRUIT_ASK_ENTITY_ATI] : []),
];

export const DEFAULT_TALENT_ENTITY_ATI: TalentEntityATI[] = ['ati:cloud:radar:position'];

export const DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI: CloudGraphDocumentEntityAti[] = [
	'ati:cloud:graph:document',
];
export const DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI: CloudGraphMessageEntityAti[] = [
	'ati:cloud:graph:message',
];
export const DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI: CloudGraphConversationEntityAti[] = [
	'ati:cloud:graph:conversation',
];
export const DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI: CloudGraphDesignEntityAti[] = [
	'ati:cloud:graph:design',
];
export const DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI: CloudGraphVideoEntityAti[] = [
	'ati:cloud:graph:video',
];
export const DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI: CloudGraphSpaceEntityAti[] = [
	'ati:cloud:graph:space',
];
export const DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI: CloudGraphCommentEntityAti[] = [
	'ati:cloud:graph:comment',
];

export const DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI: CloudGraphWorkItemEntityAti[] = [
	'ati:cloud:graph:work-item',
];

export const DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI: CloudGraphRemoteLinkEntityAti[] = [
	'ati:cloud:graph:remote-link',
];

export const DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI: CloudGraphCalendarEventEntityAti[] = [
	'ati:cloud:graph:calendar-event',
];

export const DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI: CloudGraphRepositoryEntityAti[] = [
	'ati:cloud:graph:repository',
];
export const DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI: CloudGraphPullRequestEntityAti[] =
	['ati:cloud:graph:pull-request'];
export const DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI: CloudGraphCommitEntityAti[] = [
	'ati:cloud:graph:commit',
];
export const DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI: CloudGraphBranchEntityAti[] = [
	'ati:cloud:graph:branch',
];
export const DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI: CloudGraphProjectEntityAti[] = [
	'ati:cloud:graph:project',
];
export const DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI: CloudGraphDealEntityAti[] = [
	'ati:cloud:graph:deal',
];
export const DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI: CloudGraphCustomerOrgEntityAti[] = [
	'ati:cloud:graph:customer-org',
];
export const DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI: CloudGraphDashboardEntityAti[] = [
	'ati:cloud:graph:dashboard',
];
export const DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI: CloudGraphDataTableEntityAti[] = [
	'ati:cloud:graph:data-table',
];
export const DEFAULT_CLOUD_GRAPH_CUSTOMER_CONTACT_ENTITY_ATI: CloudGraphCustomerContactEntityAti[] =
	['ati:cloud:graph:customer-contact'];

export const confluenceEntityATIPrefix = 'ati:cloud:confluence:';

export const DEFAULT_CONFLUENCE_ENTITY_ATI: ConfluenceEntityATI[] = [
	'ati:cloud:confluence:page',
	'ati:cloud:confluence:blogpost',
	'ati:cloud:confluence:attachment',
	'ati:cloud:confluence:space',
	'ati:cloud:confluence:whiteboard',
];

// TODO check references
export const PARITY_CONFLUENCE_ENTITY_ATI: ConfluenceEntityATI[] = [
	'ati:cloud:confluence:comment',
	'ati:cloud:confluence:database',
	'ati:cloud:confluence:embed',
	'ati:cloud:confluence:folder',
];

export const CONFLUENCE_CALENDAR_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';

export const CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';

export const CONFLUENCE_ANSWER_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';

export const CONFLUENCE_QUESTION_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';

export const CONFLUENCE_GLIFFY_ENTITY_ATI: ConfluenceEntityATI =
	'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';

export const JIRA_ISSUE_ENTITY_ATI = 'ati:cloud:jira:issue';
export const JIRA_PROJECT_ENTITY_ATI = 'ati:cloud:jira:project';
export const JIRA_FILTER_ENTITY_ATI = 'ati:cloud:jira:filter';
export const JIRA_DASHBOARD_ENTITY_ATI = 'ati:cloud:jira:dashboard';
export const JIRA_BOARD_ENTITY_ATI = 'ati:cloud:jira:board';
export const JIRA_PLAN_ENTITY_ATI = 'ati:cloud:jira:plan';

export const DEFAULT_JIRA_ENTITY_ATI: JiraEntityATI[] = [
	JIRA_PROJECT_ENTITY_ATI,
	JIRA_ISSUE_ENTITY_ATI,
	JIRA_FILTER_ENTITY_ATI,
	JIRA_DASHBOARD_ENTITY_ATI,
	JIRA_BOARD_ENTITY_ATI,
	JIRA_PLAN_ENTITY_ATI,
	// FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI
];

export const FEDERATED_GOOGLE_EMAIL_ENTITY_ATI = 'ati:third-party:google:email';
export const FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI = 'ati:third-party:microsoft:email';
export const FEDERATED_EMAIL_ENTITY_ATIS: FederatedEmailEntityAti[] = [
	FEDERATED_GOOGLE_EMAIL_ENTITY_ATI,
	FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI,
];

export const DEFAULT_SLACK_TYPES: SlackEntityType[] = ['message'];

export const getDefaultEntityAti = (): EntityATI[] => [
	...DEFAULT_ATLAS_ENTITY_ATI,
	...DEFAULT_CONFLUENCE_ENTITY_ATI,
	...DEFAULT_JIRA_ENTITY_ATI,
	...getMercuryEntityAti(),
	...DEFAULT_TALENT_ENTITY_ATI,
];

/**
 * Think before bumping the limits as it increases the time spent in the hydration layer.
 * We hydrate quite a few fields from Confluence , Atlas and Jira which can slow downt the calls further.
 */
export const RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS = 15;
export const RESULT_LIMIT_FOR_SINGLE_PRODUCT = 30;
